export function ManageSchoolsHeader() {
  return (
    <header className="px-4 pt-6">
      <div className="mx-auto w-full max-w-6xl">
        <h1 className="text-3xl font-extrabold tracking-tight text-gray-900">
          Schools Setup
        </h1>
        <p className="mt-2 text-sm font-medium text-gray-600">
          Management-only: create schools and view existing schools.
        </p>
      </div>
    </header>
  );
}
